<template>
  <div class="news-content">
      <div class="news-item flex fd-c ai-c" v-for="(item, index) in list" :key="index">
          <div class="t1 flex fd-c ai-c"
          v-html="item.info"></div>
      </div>
  </div>
</template>

<script>
import { findNews } from '../../api'
export default {
  components:{},
  props:{},
  data(){
    return {
        list: []
    }
  },
  watch:{},
  computed:{},
  methods:{
      findNews() {
          findNews({
            page: 1,
            limit: 100,
          }).then(res=>{
              var list = res.data.data.records
              for (var item of list) {
                    var dataArr = item.info.split('<p')
                    var str = ''
                    for (var i in dataArr) {
                        if (i==0) {
                            continue;
                        }
                        if (dataArr[i].indexOf('class="') == -1) {
                            dataArr[i] = ` data-wow-duration="0.5s" data-wow-delay="${0.02*i}s" class="listWOW fadeInDown"` + dataArr[i]
                        } else {
                            dataArr[i] = dataArr[i].replace('class="', `data-wow-duration="0.5s" data-wow-delay="${0.02*i}s" class="listWOW fadeInDown `);
                        }
                        str += '<p' + dataArr[i]
                    }
                    item.info = str
              }
              this.list = list
              this.$nextTick(()=>{
                  this.$wow('listWOW')
              })
          })
      }
  },
  created(){
      this.findNews()
  },
  mounted(){}
}
</script>
<style scoped>
.news-content{
  display:flex;
  align-items:center;
  flex-direction:column;
  padding-top:1.1rem;
}
.news-item{
  max-width:5.3rem;
  cursor:pointer;
}
.news-item+.news-item{
  margin-top:1.1rem;
}
.news-item .t1>>>*{
  color:#93278f;
  font-family:KhmerSangamMN;
  font-size:14px;
  font-weight:400;
  line-height:.34rem;
  text-align:center;
}
.news-item .t1>>>p:last-child{
  width:fit-content;
  border-bottom:1px solid rgba(228, 201, 227, 1);
}
/* .news-item .t1>>>p:last-child a{
    line-height: 14px;
} */

</style>